import { useState } from 'react'
import styles from './ComparadorDIAN.module.css'
import FileList from '@/components/FileList/FileList'

function ComparadorDIAN() {
    const [formData, setFormData] = useState({
        nombreEmpresa: '',
        tokenFile: null,
        auxiliarFile: null
    })
    const [isProcessing, setIsProcessing] = useState(false)
    const [result, setResult] = useState(null)

    const handleFileChange = (e, fileType) => {
        const file = e.target.files[0]
        if (file) {
            setFormData({
                ...formData,
                [fileType]: file
            })
        }
    }

    const handleProcess = async (e) => {
        e.preventDefault() // Prevent default form submission
        // Validar que todos los campos estén completos
        if (!formData.nombreEmpresa || !formData.tokenFile || !formData.auxiliarFile) {
            alert('Por favor complete todos los campos')
            return
        }

        setIsProcessing(true)
        setResult(null)

        try {
            // Importar servicio API dinámicamente
            const { comparadorDianWorkflow } = await import('@/services/api')

            // Ejecutar workflow completo (upload + procesamiento)
            const resultado = await comparadorDianWorkflow({
                tokenFile: formData.tokenFile,
                auxiliarFile: formData.auxiliarFile,
                nombreEmpresa: formData.nombreEmpresa
            })

            // Actualizar UI con resultados reales
            setResult({
                totalRegistros: resultado.statistics?.totalRegistros || 0,
                coincidencias: resultado.statistics?.coincidencias || 0,
                validacionManual: resultado.statistics?.validacionManual || 0,
                fileName: resultado.metadata?.archivo || 'resultado.xlsx',
                downloadUrl: resultado.downloadUrl
            })
        } catch (error) {
            console.error('Error procesando archivos:', error)
            alert('Error al procesar los archivos. Por favor intente nuevamente.')
        } finally {
            setIsProcessing(false)
        }
    }

    const isFormValid = formData.nombreEmpresa && formData.tokenFile && formData.auxiliarFile

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                {/* Header */}
                <div className={styles.header}>
                    <h1 className={styles.title}>📊 Comparador Token DIAN</h1>
                    <p className={styles.subtitle}>
                        Compara archivos Token DIAN con libros auxiliares contables de forma automatizada
                    </p>
                </div>

                {/* Upload Form */}
                <div className={styles.formCard}>
                    <form onSubmit={handleProcess} className={styles.form}>
                        <div className={styles.formGroup}>
                            <label htmlFor="nombreEmpresa" className={styles.label}>
                                Nombre de la Empresa *
                            </label>
                            <input
                                type="text"
                                id="nombreEmpresa"
                                value={formData.nombreEmpresa}
                                onChange={(e) => setFormData({ ...formData, nombreEmpresa: e.target.value })}
                                className={styles.input}
                                placeholder="Ej: Empresa ABC S.A.S."
                                required
                            />
                        </div>

                        <div className={styles.fileUploads}>
                            <div className={styles.uploadBox}>
                                <label htmlFor="tokenFile" className={styles.uploadLabel}>
                                    <div className={styles.uploadIcon}>📄</div>
                                    <div className={styles.uploadText}>
                                        <strong>Token DIAN</strong>
                                        <span>Selecciona archivo Excel (.xlsx, .xls)</span>
                                    </div>
                                    {formData.tokenFile && (
                                        <div className={styles.fileName}>✓ {formData.tokenFile.name}</div>
                                    )}
                                </label>
                                <input
                                    type="file"
                                    id="tokenFile"
                                    accept=".xlsx,.xls"
                                    onChange={(e) => handleFileChange(e, 'tokenFile')}
                                    className={styles.fileInput}
                                />
                            </div>

                            <div className={styles.uploadBox}>
                                <label htmlFor="auxiliarFile" className={styles.uploadLabel}>
                                    <div className={styles.uploadIcon}>📗</div>
                                    <div className={styles.uploadText}>
                                        <strong>Libro Auxiliar</strong>
                                        <span>Selecciona archivo Excel (.xlsx, .xls)</span>
                                    </div>
                                    {formData.auxiliarFile && (
                                        <div className={styles.fileName}>✓ {formData.auxiliarFile.name}</div>
                                    )}
                                </label>
                                <input
                                    type="file"
                                    id="auxiliarFile"
                                    accept=".xlsx,.xls"
                                    onChange={(e) => handleFileChange(e, 'auxiliarFile')}
                                    className={styles.fileInput}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={!isFormValid || isProcessing}
                            className={styles.submitBtn}
                        >
                            {isProcessing ? (
                                <>
                                    <span className="spinner"></span>
                                    Procesando...
                                </>
                            ) : (
                                'Procesar Comparación'
                            )}
                        </button>
                    </form>
                </div>

                {/* Results */}
                {result && (
                    <div className={styles.resultsCard}>
                        <h2 className={styles.resultsTitle}>✓ Procesamiento Completado</h2>

                        <div className={styles.statsGrid}>
                            <div className={styles.statBox}>
                                <div className={styles.statValue}>{result.totalRegistros}</div>
                                <div className={styles.statLabel}>Total Registros</div>
                            </div>
                            <div className={styles.statBox}>
                                <div className={styles.statValue}>{result.coincidencias}</div>
                                <div className={styles.statLabel}>Coincidencias</div>
                            </div>
                            <div className={styles.statBox}>
                                <div className={styles.statValue}>{result.validacionManual}</div>
                                <div className={styles.statLabel}>Validación Manual</div>
                            </div>
                        </div>

                        <a
                            href={result.downloadUrl}
                            download={result.fileName}
                            className={styles.downloadBtn}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            📥 Descargar Resultados
                        </a>
                    </div>
                )}

                {/* File List Section */}
                <FileList autoRefresh={isProcessing} folderFilter="comparador-dian" />
            </div>
        </div>
    )
}

export default ComparadorDIAN

